import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import AdminTabSkeleton from '@/components/v2/molecules/admin/tabs/UserManagementTabs/Admins/AdminTabSkeleton';
import { useUserManagement } from '@/hooks/useUserManagement';
import { useUsers } from '@/hooks/useUsers';
import { Plus } from 'lucide-react';
import { useState } from 'react';
import CreateUserModal from '../../shared/CreateUserModal';
import TabErrorBanner from '../../../../../molecules/admin/shared/TabErrorBanner';
import AdminCard from '../../../../../molecules/admin/tabs/UserManagementTabs/Admins/AdminCard';

const AdminUsersTab = () => {
  const [showCreateModal, setShowCreateModal] = useState(false);

  const { resendInvitation, loading: actionLoading } = useUserManagement();

  const {
    data: admins = [],
    isLoading: isLoadingAdmins,
    error: errorAdmins,
    refetch: refetchAdmins,
  } = useUsers('super_admin');

  const handleResendInvitation = async (userId: string) => {
    const { error } = await resendInvitation(userId);

    if (!error) {
      refetchAdmins();
    }
  };

  if (isLoadingAdmins) {
    return <AdminTabSkeleton />;
  }

  if (errorAdmins) {
    return (
      <TabErrorBanner
        title="Error al cargar administradores"
        message="No se pudieron cargar los administradores. Por favor, intenta nuevamente."
        onRetry={() => refetchAdmins()}
      />
    );
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Administradores</h2>
          <p className="text-gray-600">
            Gestiona los usuarios administradores del sistema
          </p>
        </div>

        <Button
          className="bg-brand-primary hover:bg-brand-primary-hover flex items-center gap-2"
          onClick={() => setShowCreateModal(true)}
        >
          <Plus className="w-4 h-4 mr-2" />
          Crear Administrador
        </Button>
      </div>

      <div className="grid gap-4">
        {!admins || admins.length === 0 ? (
          <Card>
            <CardContent className="p-8 text-center">
              <p className="text-gray-600">
                No hay administradores registrados
              </p>
            </CardContent>
          </Card>
        ) : (
          admins.map((admin) => (
            <AdminCard
              key={admin.id}
              admin={admin}
              onResendInvitation={handleResendInvitation}
              isLoading={actionLoading}
            />
          ))
        )}
      </div>

      <CreateUserModal
        isOpen={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        onSuccess={() => {
          setShowCreateModal(false);
          refetchAdmins();
        }}
        userRole="super_admin"
      />
    </div>
  );
};

export default AdminUsersTab;
